import { render } from "./SpainFlag.vue?vue&type=template&id=631fbf9c&ts=true"
import script from "./SpainFlag.vue?vue&type=script&lang=ts"
export * from "./SpainFlag.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__